import { render, staticRenderFns } from "./update-task-awards.vue?vue&type=template&id=24b9539a&scoped=true&"
import script from "./update-task-awards.vue?vue&type=script&lang=js&"
export * from "./update-task-awards.vue?vue&type=script&lang=js&"
import style0 from "./update-task-awards.vue?vue&type=style&index=0&id=24b9539a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b9539a",
  null
  
)

export default component.exports